import { useEffect, useState } from "react";
import { api, errorText } from "@/lib/api";
import { toast } from "sonner";

function ReviewItem({ item, mode, fa, refresh }) {
  const [message, setMessage] = useState("");
  const [scope, setScope] = useState("");
  const [amount, setAmount] = useState(item.amount_toman || "");
  const [credit, setCredit] = useState(0);
  const [reference, setReference] = useState("");
  const [verified, setVerified] = useState(false);
  const [expiry, setExpiry] = useState("");
  const [busy, setBusy] = useState(false);
  const [context, setContext] = useState(null);
  const identity = mode === "identity";
  const base = identity ? "/advisor/chat-escalations" : "/advisor/pricing-quotes";
  const submit = async (event) => {
    event.preventDefault();
    setBusy(true);
    try {
      if (identity) {
        await api.post(`${base}/${item.id}/reply`, { message });
      } else {
        await api.post(`${base}/${item.id}/approve`, {
          amount_toman: Number(amount), scope: scope.split("\n").map((x) => x.trim()).filter(Boolean),
          note: message, valid_until: new Date(expiry).toISOString(),
          credit_toman: Number(credit), credit_reference: reference, credit_verified: verified,
        });
      }
      toast.success(fa ? "ثبت شد." : "Saved.");
      refresh();
    } catch (error) { toast.error(errorText(error, fa ? "ثبت انجام نشد." : "Could not save.")); }
    finally { setBusy(false); }
  };
  return <form className="list-item stack-form" onSubmit={submit}>
    <strong>{identity ? (fa ? "ارجاع هویت — اولویت بالا" : "Identity review — high priority") : `${item.tier} · ${item.kind || "legacy"}`}</strong>
    <small>{item.business_name || item.business_id} · {item.created_at}</small>
    {identity && <p>{item.message}</p>}
    <button type="button" className="quiet-button" onClick={async () => {
      try { const r = await api.get(`${base}/${item.id}/context`); setContext(r.data); }
      catch (error) { toast.error(errorText(error, "Context unavailable")); }
    }}>{fa ? "مشاهده زمینه همین کسب‌وکار" : "View this business context"}</button>
    {context && <div className="founder-context"><p>{context.business?.business_name} · {context.business?.industry}</p><p>{context.business?.description}</p>{context.messages?.map((m, i) => <p key={i}><strong>{m.role}: </strong>{m.content}</p>)}</div>}
    {!identity && <>
      <label>{fa ? "مبلغ نهایی (تومان)" : "Final amount (toman)"}<input type="number" min="1" step="1" required value={amount} onChange={(e) => setAmount(e.target.value)} /></label>
      <label>{fa ? "دامنه توافق‌شده؛ هر مورد در یک خط" : "Agreed scope; one item per line"}<textarea required value={scope} onChange={(e) => setScope(e.target.value)} /></label>
      <label>{fa ? "پایان اعتبار پیشنهاد" : "Quote expiry"}<input type="datetime-local" required value={expiry} onChange={(e) => setExpiry(e.target.value)} /></label>
      {item.kind === "upgrade" && <>
        <label>{fa ? "اعتبار پرداخت قبلی (تومان)" : "Prior-payment credit (toman)"}<input type="number" min="1" step="1" required value={credit} onChange={(e) => { setCredit(e.target.value); setAmount(item.base_amount_toman - Number(e.target.value)); }} /></label>
        <label>{fa ? "مرجع قابل‌پیگیری پرداخت قبلی" : "Prior-payment reference"}<input required value={reference} onChange={(e) => setReference(e.target.value)} /></label>
        <label><input type="checkbox" required checked={verified} onChange={(e) => setVerified(e.target.checked)} />{fa ? "پرداخت قبلی را با مدرک بررسی و تأیید کرده‌ام." : "I have checked evidence and verified this prior payment."}</label>
      </>}
    </>}
    <label>{identity ? (fa ? "پاسخ انسانی برای ارسال به مشتری" : "Human-written reply to send") : (fa ? "یادداشت داخلی بررسی" : "Internal review note")}<textarea required value={message} onChange={(e) => setMessage(e.target.value)} /></label>
    <button className="primary-button" disabled={busy || (!identity && !item.catalog_version)}>{identity ? (fa ? "ارسال همین پاسخ انسانی" : "Send this human reply") : (fa ? "تأیید مبلغ و دامنه؛ بدون دریافت وجه" : "Approve scope and price; no charge")}</button>
    {!identity && !item.catalog_version && <small>{fa ? "درخواست قدیمی است؛ مشتری باید درخواست جدید ثبت کند." : "Legacy request: a new request is required."}</small>}
  </form>;
}

export default function FounderReview({ lang, mode }) {
  const [items, setItems] = useState([]);
  const fa = lang === "fa";
  const refresh = async () => {
    try { const r = await api.get(mode === "identity" ? "/advisor/chat-escalations" : "/advisor/pricing-quotes"); setItems(r.data.items || r.data.quotes || []); }
    catch (error) { toast.error(errorText(error, "Review inbox unavailable")); }
  };
  useEffect(() => { refresh(); }, [mode]); // eslint-disable-line react-hooks/exhaustive-deps
  return <section className="list founder-review" data-testid="founder-review">
    <h3>{fa ? "صندوق بررسی انسانی" : "Human review inbox"}</h3>
    <button className="quiet-button" onClick={refresh}>{fa ? "تازه‌سازی" : "Refresh"}</button>
    {items.length === 0 && <p className="muted">{fa ? "موردی در انتظار بررسی نیست." : "No pending reviews."}</p>}
    {items.map((item) => <ReviewItem key={item.id} item={item} mode={mode} fa={fa} refresh={refresh} />)}
  </section>;
}
